module.exports = __webpack_public_path__ + "img/icon.551539f8.png";